/* =========================================
   North Arrow Coffee - Seal Subscriptions
   Welcome Header Injection Script

   INSTRUCTIONS:
   Add this JavaScript to your Shopify theme:

   Option 1: Add as a separate JS file
   1. Go to Online Store > Themes > Edit Code
   2. Under Assets, click "Add a new asset"
   3. Create a new file called "seal-subscriptions-custom.js"
   4. Paste this entire code
   5. Add to your theme.liquid (before </body>):
      <script src="{{ 'seal-subscriptions-custom.js' | asset_url }}" defer></script>

   Option 2: Add directly to theme.liquid
   1. Open layout/theme.liquid
   2. Paste this code inside <script> tags before </body>
   ========================================= */

(function() {
  'use strict';

  // Configuration - Edit these values to customize the welcome message
  var config = {
    heading: 'Manage Your Subscription',
    tagline: 'Update, pause, or manage your Coffee For Life subscription anytime'
  };

  // Function to inject the welcome header
  function injectWelcomeHeader() {
    // Find the Seal subscription page container
    var sealPage = document.querySelector('.seal-subscription-page');

    if (!sealPage) {
      return false; // Not on the subscription page
    }

    // Check if we already injected the header
    if (document.querySelector('.na-welcome-header')) {
      return true; // Already done
    }

    // Find the wrapper that contains the card (seal-auto-min)
    var wrapper = sealPage.querySelector('.seal-auto-min');

    if (!wrapper) {
      return false;
    }

    // Create the welcome header element
    var welcomeHeader = document.createElement('div');
    welcomeHeader.className = 'na-welcome-header';
    welcomeHeader.innerHTML = '<h1>' + config.heading + '</h1><p class="na-tagline">' + config.tagline + '</p>';

    // Insert the welcome header before the wrapper
    sealPage.insertBefore(welcomeHeader, wrapper);
    return true;
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectWelcomeHeader);
  } else {
    injectWelcomeHeader();
  }

  // Also run when Seal portal loads (in case it loads dynamically)
  document.addEventListener('sealsubs_portal:loaded', injectWelcomeHeader);

  // Fallback: Check periodically for a short time in case of slow loading
  var attempts = 0;
  var maxAttempts = 20;
  var checkInterval = setInterval(function() {
    attempts++;
    var success = injectWelcomeHeader();
    if (success || attempts >= maxAttempts) {
      clearInterval(checkInterval);
    }
  }, 300);

})();